function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { createContext, useContext } from "react";
import Head from "next/head";
// import nodeFetch from "node-fetch";
import nodeFetch from "isomorphic-fetch";
import { composeDataMethods } from "@lululemon/mwa-utils";
import logger, { LapelError } from "../logger";
var statsCache = {};
function loadRemoteStats(wrappedFetch, remote, remotes) {
    return _loadRemoteStats.apply(this, arguments);
}
function _loadRemoteStats() {
    _loadRemoteStats = _async_to_generator(function(wrappedFetch, remote, remotes) {
        var res, json;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!remotes[remote] || !remotes[remote].stats) {
                        return [
                            2,
                            null
                        ];
                    }
                    // only request stats files once per remote
                    if (statsCache[remote]) {
                        return [
                            2,
                            statsCache[remote]
                        ];
                    }
                    return [
                        4,
                        wrappedFetch(remotes[remote].stats)
                    ];
                case 1:
                    res = _state.sent();
                    if (!res.ok) {
                        return [
                            2,
                            null
                        ];
                    }
                    json = res.json();
                    statsCache[remote] = json;
                    return [
                        2,
                        json
                    ];
            }
        });
    });
    return _loadRemoteStats.apply(this, arguments);
}
function getChunksForFederatedModules(remote, stats, remotes, modules) {
    if (!remote || !stats || !stats.federatedModules || !remotes || !remotes[remote] || !modules) {
        return [];
    }
    // Search for the remote in the federation stats json file
    // this should tell us all the dependencies we need for our modules
    var federatedModuleStats = stats.federatedModules.find(function(federatedModuleStatsFilter) {
        return federatedModuleStatsFilter.remote === remote;
    });
    if (!federatedModuleStats || !federatedModuleStats.exposes) {
        return [];
    }
    var publicPath = remotes[remote].entry.split("/").slice(0, -1).join("/");
    var chunks = [];
    // for ever module we've been told to preload that is also exposed by this remote entry
    // We also want to load all the chunks required for ths module to function
    Object.entries(modules).forEach(function(param) {
        var _param = _sliced_to_array(param, 2), mod = _param[0], refs = _param[1];
        if (!refs || !federatedModuleStats.exposes[mod]) {
            return;
        }
        federatedModuleStats.exposes[mod].forEach(function(exposes) {
            exposes.chunks.forEach(function(chunk) {
                chunks.push(publicPath + "/" + chunk);
            });
        });
    });
    return chunks;
}
var withRemoteModulePreloadContext = /*#__PURE__*/ createContext(null);
var RemoteModulePreloadProvider = withRemoteModulePreloadContext.Provider;
function useRemoteModulePreloadContext() {
    return useContext(withRemoteModulePreloadContext);
}
export function useRemoteModulePreload(param) {
    var remote = param.remote, mod = param.module;
    var remoteModulePreloads = (useRemoteModulePreloadContext() || {}).remoteModulePreloads;
    // We only run in the server
    // remoteModulePreloads would most likely be undefined if the withRemoteModulePreload hoc was not used on the app
    if (typeof window !== "undefined") {
        return;
    }
    if (!remoteModulePreloads) {
        logger.warn(new LapelError("An attempt to use useRemoteModulePreload was made, when the HOC withRemoteModulePreload was not used in the application!"));
        return;
    }
    var prefixedMod = mod.startsWith("./") ? mod : "./" + mod;
    var remoteModules = remoteModulePreloads[remote] || {};
    remoteModulePreloads[remote] = remoteModules;
    remoteModules[prefixedMod] = true;
}
export function withRemoteModulePreload(param) {
    var remotes = param.remotes, _param_getAkamaiToken = param.getAkamaiToken, getAkamaiToken = _param_getAkamaiToken === void 0 ? function(appContext) {
        var _ctx_req_app_locals, _ctx_req_app, _ctx_req, _ctx;
        var ctx = appContext.ctx || appContext;
        return (_ctx = ctx) == null ? void 0 : (_ctx_req = _ctx.req) == null ? void 0 : (_ctx_req_app = _ctx_req.app) == null ? void 0 : (_ctx_req_app_locals = _ctx_req_app.locals) == null ? void 0 : _ctx_req_app_locals.getSecret("akamai-token");
    } : _param_getAkamaiToken;
    // we pass in the list of remote entries for the current app using this HOC
    return function(Component) {
        // Creating the HOC to render our preload tags
        var WithRemoteModulePreload = function(_param) {
            var remoteModulePreloadContext = _param.remoteModulePreloadContext, params = _object_without_properties_loose(_param, [
                "remoteModulePreloadContext"
            ]);
            var preloadTags = (remoteModulePreloadContext || {}).preloadTags;
            return /*#__PURE__*/ _jsxs(RemoteModulePreloadProvider, {
                value: remoteModulePreloadContext,
                children: [
                    /*#__PURE__*/ _jsx(Head, {
                        children: preloadTags ? preloadTags.map(function(tag) {
                            return /*#__PURE__*/ _jsx("link", _extends({
                                rel: "preload"
                            }, tag), tag.href);
                        }) : null
                    }),
                    /*#__PURE__*/ _jsx(Component, _extends({}, params))
                ]
            });
        };
        // Now we're using composition of data methods to make sure previous HOCs still function
        // But we also want to extend some of the functionality
        var wrappedFetch;
        return composeDataMethods(Component, {
            prepareInitialPropsContext: /*#__PURE__*/ _async_to_generator(function(appContext) {
                var ctx;
                return _ts_generator(this, function(_state) {
                    ctx = appContext.ctx || appContext; // This looks like a hack for backwards compatibility with older lulu apps.
                    // this could be moved into it's own HOC if other HOCs start using node-fetch
                    wrappedFetch = /*#__PURE__*/ _async_to_generator(function(url, opts) {
                        var _opts, appFetch, _tmp, _tmp1, _tmp2, _tmp3, _tmp4, _;
                        return _ts_generator(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    appFetch = ctx.fetch || global.wrappedFetch || nodeFetch;
                                    _tmp = [
                                        url
                                    ];
                                    _tmp1 = [
                                        {},
                                        opts
                                    ];
                                    _tmp2 = {};
                                    _tmp3 = [
                                        {},
                                        (_opts = opts) == null ? void 0 : _opts.headers
                                    ];
                                    _tmp4 = {
                                        "User-Agent": "lululemon/lapel"
                                    };
                                    _ = "x-lll-access-token";
                                    return [
                                        4,
                                        getAkamaiToken(appContext)
                                    ];
                                case 1:
                                    return [
                                        2,
                                        appFetch.apply(void 0, _tmp.concat([
                                            _extends.apply(void 0, _tmp1.concat([
                                                (_tmp2.headers = _extends.apply(void 0, _tmp3.concat([
                                                    (_tmp4[_] = _state.sent(), _tmp4)
                                                ])), _tmp2)
                                            ]))
                                        ]))
                                    ];
                            }
                        });
                    });
                    return [
                        2
                    ];
                });
            }),
            getInitialProps: function() {
                return {
                    // First we're providing initial props, this should load our preloadContext with the inital object we need
                    // to track what modules we're preloading
                    remoteModulePreloadContext: {
                        remoteModulePreloads: {}
                    }
                };
            },
            postProcessInitialProps: /*#__PURE__*/ _async_to_generator(function(_param) {
                var remoteModulePreloadContext, rest, remoteModulePreloads, chunks, uniqueChunks, preloadTags;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            remoteModulePreloadContext = _param.remoteModulePreloadContext, rest = _object_without_properties_loose(_param, [
                                "remoteModulePreloadContext"
                            ]);
                            remoteModulePreloads = remoteModulePreloadContext.remoteModulePreloads;
                            chunks = [];
                            return [
                                4,
                                Promise.all(Object.entries(remoteModulePreloads).map(function(param) {
                                    var _$_param = _sliced_to_array(param, 2), remote = _$_param[0], modules = _$_param[1];
                                    return _async_to_generator(function() {
                                        var _chunks, stats, _, _1, _tmp;
                                        return _ts_generator(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        loadRemoteStats(wrappedFetch, remote, remotes)
                                                    ];
                                                case 1:
                                                    stats = _state.sent();
                                                    _1 = (_ = (_chunks = chunks).push).apply;
                                                    _tmp = [
                                                        _chunks
                                                    ];
                                                    return [
                                                        4,
                                                        getChunksForFederatedModules(remote, stats, remotes, modules)
                                                    ];
                                                case 2:
                                                    _1.apply(_, _tmp.concat([
                                                        _to_consumable_array.apply(void 0, [
                                                            _state.sent()
                                                        ])
                                                    ]));
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    })().catch(function(error) {
                                        logger.error(error);
                                    });
                                }))
                            ];
                        case 1:
                            _state.sent();
                            uniqueChunks = Array.from(new Set(chunks));
                            preloadTags = uniqueChunks.map(function(href) {
                                return {
                                    href: href,
                                    as: href.endsWith(".css") ? "stylesheet" : "script"
                                };
                            });
                            // Applying a new value to our context, so the final render will use this to render our preload tags
                            return [
                                2,
                                _extends({}, rest, {
                                    remoteModulePreloadContext: {
                                        preloadTags: preloadTags
                                    }
                                })
                            ];
                    }
                });
            })
        })(WithRemoteModulePreload); // Here we give it our HOC we created above, which actually renders our preload tags
    };
}

//# sourceMappingURL=remote-module-preload.js.map